module.exports = __webpack_public_path__ + "bca12756b2f4e86002cf8f38f5b88475.pdf";